declare namespace $ {

	type __shm_hitalama_dragtree_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_dragtree['dragged'] >[0]
		,
		Parameters< $shm_hitalama_dragtree['Drag'] >[0]
	>
	type $mol_view__attr_shm_hitalama_dragtree_2 = $mol_type_enforce<
		({ 
			'guide_orientation': ReturnType< $shm_hitalama_dragtree['guide_orientation'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__style_shm_hitalama_dragtree_3 = $mol_type_enforce<
		({ 
			'left': ReturnType< $shm_hitalama_dragtree['guide_left_px'] >,
			'top': ReturnType< $shm_hitalama_dragtree['guide_top_px'] >,
			'bottom': ReturnType< $shm_hitalama_dragtree['guide_bottom_px'] >,
			'width': ReturnType< $shm_hitalama_dragtree['guide_width_px'] >,
			'height': ReturnType< $shm_hitalama_dragtree['guide_height_px'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_dragtree_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree['guide_views'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_dragtree_toggle__style_shm_hitalama_dragtree_5 = $mol_type_enforce<
		({ 
			'display': ReturnType< $shm_hitalama_dragtree['toggle_display'] >,
		})  & ReturnType< $shm_hitalama_dragtree_toggle['style'] >
		,
		ReturnType< $shm_hitalama_dragtree_toggle['style'] >
	>
	type $shm_hitalama_dragtree_toggle__expanded_shm_hitalama_dragtree_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree['toggle_expanded'] >
		,
		ReturnType< $shm_hitalama_dragtree_toggle['expanded'] >
	>
	type $shm_hitalama_dragtree_toggle__pointerdown_shm_hitalama_dragtree_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree['toggle_pointerdown'] >
		,
		ReturnType< $shm_hitalama_dragtree_toggle['pointerdown'] >
	>
	type $mol_view__sub_shm_hitalama_dragtree_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_dragtree_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_dragtree_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_dragtree_item__on_drag_start_shm_hitalama_dragtree_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree['on_drag_start'] >
		,
		ReturnType< $shm_hitalama_dragtree_item['on_drag_start'] >
	>
	type $shm_hitalama_dragtree_item__on_drag_end_shm_hitalama_dragtree_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree['on_drag_end'] >
		,
		ReturnType< $shm_hitalama_dragtree_item['on_drag_end'] >
	>
	type $shm_hitalama_dragtree_item__top_shm_hitalama_dragtree_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree['y'] >
		,
		ReturnType< $shm_hitalama_dragtree_item['top'] >
	>
	type $shm_hitalama_dragtree_item__left_shm_hitalama_dragtree_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree['x'] >
		,
		ReturnType< $shm_hitalama_dragtree_item['left'] >
	>
	type $shm_hitalama_dragtree_item__sub_shm_hitalama_dragtree_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_dragtree_item['sub'] >
	>
	type $mol_view__sub_shm_hitalama_dragtree_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree['drop_guide_views'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_dragtree_17 = $mol_type_enforce<
		({ 
			'display': ReturnType< $shm_hitalama_dragtree['drop_display'] >,
			'top': ReturnType< $shm_hitalama_dragtree['drop_top_px'] >,
			'left': ReturnType< $shm_hitalama_dragtree['drop_left_px'] >,
			'height': ReturnType< $shm_hitalama_dragtree['drop_height_px'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_dragtree_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_hitalama_dragtree_19 = $mol_type_enforce<
		({ 
			'height': ReturnType< $shm_hitalama_dragtree['full_height_px'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_dragtree_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_dragtree extends $mol_view {
		on_drag_start( id: any, next?: any ): any
		on_drag_end( id: any, next?: any ): any
		dragged( id: any): ReturnType< ReturnType< $shm_hitalama_dragtree['Drag'] >['dragged'] >
		y( id: any, next?: number ): number
		x( id: any, next?: number ): number
		guide_orientation( id: any): string
		guide_left_px( id: any): string
		guide_top_px( id: any): string
		guide_bottom_px( id: any): string
		guide_width_px( id: any): string
		guide_height_px( id: any): string
		Guide( id: any): $mol_view
		guide_views( id: any): readonly(any)[]
		Guides( id: any): $mol_view
		toggle_display( id: any): string
		toggle_expanded( id: any, next?: boolean ): boolean
		toggle_pointerdown( id: any, next?: any ): any
		Toggle( id: any): $shm_hitalama_dragtree_toggle
		id( id: any): string
		Item( id: any): $mol_view
		Content( id: any): $mol_view
		Row( id: any): $mol_view
		Drag( id: any): $shm_hitalama_dragtree_item
		drop_display( ): string
		drop_top_px( ): string
		drop_left_px( ): string
		drop_height_px( ): string
		drop_guide_views( ): readonly(any)[]
		Drop_guides( ): $mol_view
		New_pos( ): $mol_view
		full_height_px( ): string
		Panel( ): $mol_view
		indent( ): number
		item_height_default( ): number
		drop_item_offset_default( ): number
		roots( next?: readonly(any)[] ): readonly(any)[]
		children( id: any, next?: readonly(any)[] ): readonly(any)[]
		can_have_children( id: any): boolean
		expanded( id: any, next?: boolean ): boolean
		drop_active( next?: boolean ): boolean
		drop_top( next?: number ): number
		drop_left( next?: number ): number
		drop_height( next?: number ): number
		drop_parent( next?: any ): any
		drop_index( next?: number ): number
		drag_x( next?: number ): number
		drag_y( next?: number ): number
		items( ): readonly(any)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=dragtree.view.tree.d.ts.map